module.exports = __webpack_public_path__ + "static/media/intro.12e530f2.mp3";